module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-liquid-FAT.js";